import { IStyle } from '~/assets/interfaces/classes'

interface DeviceContext {
  isMobileOrTablet: boolean
}

export const classDevice = (device: DeviceContext) => {
  return (module: IStyle) => {
    return {
      [module.mobile]: device.isMobileOrTablet,
      [module.desktop]: !device.isMobileOrTablet,
    }
  }
}
